export default "__VITE_ASSET__Dm_Rhv48__"